import * as Sentry from '@sentry/browser';

export const captureException = e => {
  if (process.env.NODE_ENV === 'production') {
    Sentry.captureException(e);
  } else if (process.env.NODE_ENV === 'development') {
    // Locally, log everything to the console instead of Sentry
    console.warn('Sentry -> captureException:', e); // eslint-disable-line no-console
  }
};

export const initialize = () => {
  if (process.env.NODE_ENV === 'production') {
    Sentry.init({
      dsn: 'https://6b2027205c9f41b09958c40d73c795d8@sentry.io/1329171',
      // When provided a string, Sentry will filter out partial matches.
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/filtering/?original_referrer=https%3A%2F%2Fwww.google.com%2F#using-platformidentifier-nameignore-errors-
      ignoreErrors: ['style', 'null'],
      beforeSend(event) {
        const isUserBlocked = event.tags?.user_blocked_submission === 'true';
        event.tags = {
          ...event.tags,
          severity_level: isUserBlocked ? 'critical' : 'low',
        };
        return event;
      },
    });
  }
};

export const setTag = (key, value) => {
  Sentry.setTag(key, value);
};

export const captureServerRefusalError = (error, endpoint, payload, response, additionalContext = {}) => {
  if (process.env.NODE_ENV === 'production') {
    Sentry.withScope(scope => {
      scope.setTag('endpoint', endpoint);
      scope.setContext('api_endpoint', { url: endpoint });

      if (payload) {
        scope.setContext('request_payload', payload);
      }

      if (response) {
        scope.setContext('response_data', {
          status: response.status,
          statusText: response.statusText,
          body: response.body,
          headers: response.headers,
        });
      }

      scope.setContext('server_refusal_metadata', {
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
        ...additionalContext,
      });

      scope.setTag('error_type', 'server_refusal');
      scope.setTag('endpoint_path', endpoint.split('?')[0]);

      if (additionalContext.tags) {
        Object.entries(additionalContext.tags).forEach(([key, value]) => {
          scope.setTag(key, value);
        });
      }

      Sentry.captureException(error);
    });
  } else if (process.env.NODE_ENV === 'development') {
    console.warn('Sentry -> captureServerRefusalError:', error, { endpoint, payload, response, additionalContext }); // eslint-disable-line no-console
  }
};
